import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import tts from '../../lib/TTS.js'
import { useEvergreenMessaging } from './EvergreenMessagingProvider'
import { DEFAULT_DISPLAY_URL_TEXT_COLOR } from './types'

const isValidHexColor = (color: string): boolean =>
  /^#[0-9A-Fa-f]{6}$/.test(color)

function EvergreenMoreInfo() {
  const navigate = useNavigate()
  const { messagingConfig } = useEvergreenMessaging()

  useKeyDown(KeyTypeEnum.Back, () => {
    navigate(-1)
  })

  useEffect(() => {
    if (messagingConfig) {
      googleAnalytics4.sendPageViewEvent('National Messaging - More Info')
    }
  }, [])

  useEffect(() => {
    tts.stopRead()
    if (messagingConfig) {
      const parts = [messagingConfig.headerText]
      if (messagingConfig.descriptionText)
        parts.push(messagingConfig.descriptionText)
      parts.push(messagingConfig.ctaText)
      parts.push(messagingConfig.displayUrl)
      tts.addTextToRead(parts.join('. '))
    }
    return () => tts.stopRead()
  }, [])

  if (!messagingConfig) {
    return null
  }

  const {
    headerText,
    descriptionText,
    ctaText,
    displayUrl,
    displayUrlTextColor,
    qrCodeImageUrl,
  } = messagingConfig

  const urlColor = isValidHexColor(displayUrlTextColor)
    ? displayUrlTextColor
    : DEFAULT_DISPLAY_URL_TEXT_COLOR

  return (
    <div className="evergreen-more-info">
      <div className="evergreen-more-info__left">
        <h1 className="evergreen-more-info__header">{headerText}</h1>
        {descriptionText && (
          <p className="evergreen-more-info__description">{descriptionText}</p>
        )}
      </div>

      <div className="evergreen-more-info__divider" />

      <div className="evergreen-more-info__right">
        <span className="evergreen-more-info__cta-text">{ctaText}</span>
        <span
          className="evergreen-more-info__display-url"
          style={{ color: urlColor }}
        >
          {displayUrl}
        </span>
        {qrCodeImageUrl && (
          <img
            className="evergreen-more-info__qr-image"
            src={qrCodeImageUrl}
            alt="QR Code"
          />
        )}
      </div>
    </div>
  )
}

export default EvergreenMoreInfo
